<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "BlujayBcaMasterLocationIndex",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  